import { AxiosError } from 'axios'
import { axiosPut } from 'shared/api/axios'
import displayGenError from 'shared/utils/displayGenError'
import Entity from '../types/Entity'
import displayError from 'shared/utils/displayError'

interface handleToggleActiveProps {
  row: Entity
  relationalFieldName: string
  url: string
  rows: Array<any>
  setRows: Function
  setDisableActions: Function
}

const handleToggleActive = async (props: handleToggleActiveProps) => {
  props.setDisableActions(true)

  const catchFunc = (err: AxiosError) => {
    const message: string = err.response!.data?.message ?? 'An error has occurred.'
    displayError({
      errorMessage: message,
      setShowOverlay: () => {},
    })
  }

  const id: string | number = props.row[props.relationalFieldName]
  const formData = {
    active: props.row.active ? 0 : 1,
  }

  const response = await axiosPut(props.url + '/' + id, formData, catchFunc)

  props.setDisableActions(false)

  if (response.status === 200) {
    const row = props.row
    row.active = !props.row.active
    props.setRows((prevRows) => prevRows.map((r) => (row.id === r.id ? { ...row } : r)))
  } else {
    displayGenError({ setShowOverlay: () => {} })
  }
}

export default handleToggleActive
